import { render } from "./ChatGroupList.vue?vue&type=template&id=6e8cd617&scoped=true"
import script from "./ChatGroupList.vue?vue&type=script&lang=js"
export * from "./ChatGroupList.vue?vue&type=script&lang=js"

import "./ChatGroupList.vue?vue&type=style&index=0&id=6e8cd617&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8cd617"],['__file',"src/views/qywx/ai/quotation/ChatGroupList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e8cd617"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e8cd617', __exports__)) {
    api.reload('6e8cd617', __exports__)
  }
  
  module.hot.accept("./ChatGroupList.vue?vue&type=template&id=6e8cd617&scoped=true", () => {
    api.rerender('6e8cd617', render)
  })

}


export default __exports__